// extracted by mini-css-extract-plugin
export var coreValues = "product-advantages-detail-module--coreValues--DPdxf";
export var coreValuesList = "product-advantages-detail-module--coreValuesList--718j-";
export var description = "product-advantages-detail-module--description--TbYkw";
export var features = "product-advantages-detail-module--features--BRgkB";
export var logo = "product-advantages-detail-module--logo--HAl7N";
export var productAdvantagesDetail = "product-advantages-detail-module--productAdvantagesDetail--VtEgd";